import { getBaseMetaTitle } from '@/environments'

const Main = () => import('./Main')

const route = {
  path: '/about',
  name: 'about',
  meta: {
    title: `About - ${getBaseMetaTitle}`
  },
  component: Main
}

export default route
